import React, { useState } from "react";
import styled from "styled-components";
import assets from "../../../assets/assets";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { mn } from "date-fns/locale";
import { IconController } from "../../Scripts/ImgController";
import {
    startOfWeek,
    endOfWeek,
    subWeeks,
    subMonths,
    startOfMonth,
    endOfMonth,
    setMonth,
    getMonth, subDays, endOfYesterday, startOfYesterday,
} from "date-fns";
import { useEffect } from "react";
import Ripples from "react-ripples";
import useIsMobile from "../../Scripts/useIsMobile";
import { mobileBottomSheet, mobileOverlay } from "../../Scripts/mobileBottomSheet";
const Wrapper = styled.div`
  border: 1px solid black;
  border-radius: 99px;
  cursor: pointer;
`;
const Popup = styled.div`
  position: absolute;
  top: 90px;
  z-index: 103 !important;

  .modal {
    width: 425px;
    background: #ffffff;
    border: 1px solid #f3f4f6;
    box-shadow: 0px 20px 25px -5px rgba(0, 0, 0, 0.1),
      0px 10px 10px -5px rgba(0, 0, 0, 0.04);
    border-radius: 12px;
    display: flex;
    flex-direction: column;
  }
  .date-container {
    display: inline-block;
  }
  .input-container {
    position: relative;
  }
  .react-datepicker {
    border: none;
    font-family: "Montserrat", sans-serif;
  }
  .date-a11y {
    border-right: 1px solid #e5e7eb;
  }
  .date-a11y span {
    padding: 8px;
    font-size: 12px;
    font-weight: 500;
    cursor: pointer;
  }
  .date-a11y span.date-active {
    background: linear-gradient(
      270deg,
      rgba(0, 97, 255, 0.2) 0%,
      rgba(0, 97, 255, 0) 100%
    );
    border-right: 3px solid #0061ff;
  }
  .dateshde:hover {
    background: linear-gradient(
      270deg,
      rgba(0, 97, 255, 0.2) 0%,
      rgba(0, 97, 255, 0) 100%
    );
  }
  .date-clear-field {
    border-top: 1px solid #e5e7eb;
  }
  .react-datepicker {
    width: 100%;
    height: 100%;
  }
  .react-datepicker__month-container {
    width: 100%;
    height: 100%;
  }
  .react-datepicker__navigation-icon::before {
    content: none;
  }
  .react-datepicker__navigation-icon {
    background-image: url(${assets.svg.prevMonth});
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;

    width: 32px;
    height: 32px;
    top: 10px;
    left: 10px;
  }
  .react-datepicker__navigation--next .react-datepicker__navigation-icon {
    background-image: url(${assets.svg.nextMonth});
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;
    width: 32px;
    height: 32px;
    top: 10px;
    right: 10px;
  }
  .react-datepicker__navigation--next {
    right: 10px;
  }
  .react-datepicker__header {
    background: none;
  }
  .react-datepicker__current-month {
    padding-top: 8px;
  }
  .react-datepicker__navigation {
    overflow: visible;
  }
  .react-datepicker__day-name {
    font-size: 12px;
    font-weight: 600;
  }
  .react-datepicker__day--in-selecting-range:not(
      .react-datepicker__day--in-range,
      .react-datepicker__month-text--in-range,
      .react-datepicker__quarter-text--in-range,
      .react-datepicker__year-text--in-range
    ),
  .react-datepicker__month-text--in-selecting-range:not(
      .react-datepicker__day--in-range,
      .react-datepicker__month-text--in-range,
      .react-datepicker__quarter-text--in-range,
      .react-datepicker__year-text--in-range
    ),
  .react-datepicker__quarter-text--in-selecting-range:not(
      .react-datepicker__day--in-range,
      .react-datepicker__month-text--in-range,
      .react-datepicker__quarter-text--in-range,
      .react-datepicker__year-text--in-range
    ),
  .react-datepicker__year-text--in-selecting-range:not(
      .react-datepicker__day--in-range,
      .react-datepicker__month-text--in-range,
      .react-datepicker__quarter-text--in-range,
      .react-datepicker__year-text--in-range
    ) {
    background: #60a5fa;
    border-radius: 32px;
    font-weight: 600;
  }
  .react-datepicker__day--selected:hover {
    background: #60a5fa;
    border-radius: 32px;
    font-weight: 600;
  }
  .react-datepicker__day--selected {
    background: #60a5fa;
    border-radius: 32px;
    font-weight: 600;
  }
  .react-datepicker__day--in-range {
    background: #60a5fa;
    border-radius: 32px;
    font-weight: 600;
  }
  .react-datepicker__day--outside-month {
    visibility: hidden;
  }
  @media (max-width: 767px) {
    .date-a11y {
      border-right: none;
      border-bottom: 1px solid #e5e7eb;
    }
    .date-a11y span {
      white-space: nowrap;
    }
    .date-a11y span.date-active {
      border-right: none;
      border-bottom: 3px solid #0061ff;
    }
    .react-datepicker {
      display: flex;
      justify-content: center;
    }
  }
  ${mobileBottomSheet(".modal")}
`;
const Overlay = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 102 !important;
  top: 0;
  left: 0;
  ${mobileOverlay}
`;

const DateSelectDropdown = ({
  width,
  setDateFilter,
  newRequest,
  setNewRequest,
  setCKPopup,
  setCKPopupType,
  setCKPopupMessage,
  minDate,
}) => {
  const dateOptions = (window.location.pathname.startsWith("/karaoke") ? [
        { title: "Өнгөрсөн сар", days: "lastMonth" },
        { title: "Сүүлийн 30 хоног", days: 30 },
        { title: "Сүүлийн 90 хоног", days: 90 },
        { title: "Сүүлийн 6 сар", days: "last6month" },
      ] : [
        { title: "Өчигдөр", days: "yesterday" },
        { title: "Өнгөрсөн 7 хоног", days: "lastWeek" },
        { title: "Энэ сар", days: "thisMonth" },
        { title: "Өнгөрсөн сар", days: "lastMonth" },
        { title: "Сүүлийн 30 хоног", days: 30 },
        { title: "Сүүлийн 90 хоног", days: 90 },
        { title: "Сүүлийн 6 сар", days: "last6month" },
  ]);

  const [popup, setPopup] = useState(false);
  const isMobile = useIsMobile();
  const [selectedStartDate, setSelectedStartDate] = useState("");
  const [selectedEndDate, setSelectedEndDate] = useState("");
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(null);
  const [dateA11y, setDateA11y] = useState("last6month");
  const [canSort, setCanSort] = useState(true);
  useEffect(() => {
    daySelectHandler("last6month");
  }, []);

  const checkDateNotExceeded = (a1, a2, a3, b1, b2, b3) => {
    return (
      Math.ceil(
        Math.abs(
          new Date(a1 + "/" + a2 + "/" + a3) -
            new Date(b1 + "/" + b2 + "/" + b3)
        ) /
          (1000 * 60 * 60 * 24)
      ) >= 184
    );
  };
  const oneFuncRulesAll = (
    selectedStartDate,
    selectedEndDate,
    startDate,
    endDate,
    dateFilter,
    days
  ) => {
    setSelectedStartDate(selectedStartDate);
    setSelectedEndDate(selectedEndDate);
    // Carickao: ene deed 2 zuvhun ter haruulj baigaa string g udirddag
    setStartDate(startDate);
    setEndDate(endDate);
    // Carickao: ene deed 2 zuvhun calendar deer haruulahiig udirddag
    setDateFilter(dateFilter);
    setDateA11y(days);
  };
  const onCalendarChange = (dates) => {
    const [start, end] = dates;
    const filteredStartDate = new Date(start);
    const filteredEndDate = new Date(end);

    const newStartDate = new Date(
      filteredStartDate.getFullYear(),
      filteredStartDate.getMonth(),
      filteredStartDate.getDate()
    );
    const newEndDate = new Date(
      filteredEndDate.getFullYear(),
      filteredEndDate.getMonth(),
      filteredEndDate.getDate()
    );

    const startYear = newStartDate.getFullYear();
    const startMonth = newStartDate.getMonth() + 1; // January is 0, so you may want to add 1 to match human-readable month numbering
    const startDay = newStartDate.getDate();
    const endYear = newEndDate.getFullYear();
    const endMonth = newEndDate.getMonth() + 1; // January is 0, so you may want to add 1 to match human-readable month numbering
    const endDay = newEndDate.getDate();
    setStartDate(start);
    setEndDate(end);
    if (end !== null) {
      if (
        checkDateNotExceeded(
          startYear,
          startMonth,
          startDay,
          endYear,
          endMonth,
          endDay
        )
      ) {
        setCanSort(false);
        setCKPopupType("Warning");
        setCKPopupMessage("dateExceeded");
        setCKPopup(true);
      } else {
        oneFuncRulesAll(
          startYear + "/" + startMonth + "/" + startDay,
          endYear + "/" + endMonth + "/" + endDay,
          start,
          end,
          "filter[date][starts]=" +
            startYear +
            "-" +
            startMonth +
            "-" +
            startDay +
            "&filter[date][ends]=" +
            endYear +
            "-" +
            endMonth +
            "-" +
            endDay,
          "chosen"
        );
        // setDateFilter("filter[date][starts]=" + startYear + "-" + startMonth + "-" + startDay + "&filter[date][ends]=" + endYear + "-" + endMonth + "-" + endDay);
        setCanSort(true);
      }
    }
  };

  const daySelectHandler = (days) => {
    const dateMinusOne = addDays(new Date(), -1);
    let date;
    let startDate;
    let endDate;
    setCanSort(true);
    if (typeof days === "number") {
      date = addDays(new Date(), -days);
      oneFuncRulesAll(
        date.getFullYear() + "/" + (date.getMonth() + 1) + "/" + date.getDate(),
        dateMinusOne.getFullYear() +
          "/" +
          (dateMinusOne.getMonth() + 1) +
          "/" +
          dateMinusOne.getDate(),
        new Date(date.getFullYear(), date.getMonth(), date.getDate()),
        dateMinusOne,
        "filter[date][starts]=" +
          date.getFullYear() +
          "-" +
          (date.getMonth() + 1) +
          "-" +
          date.getDate() +
          "&filter[date][ends]=" +
          dateMinusOne.getFullYear() +
          "-" +
          (dateMinusOne.getMonth() + 1) +
          "-" +
          dateMinusOne.getDate(),
        days
      );
    } else {
      switch (days) {
        case "last6month":
          const targetMonth = (getMonth(dateMinusOne) - 6 + 12) % 12;
          const resultDate = setMonth(subMonths(dateMinusOne, 6), targetMonth);
          startDate = resultDate;
          endDate = dateMinusOne;
          break;
        case "lastWeek":
          date = subWeeks(new Date(), 1);
          startDate = startOfWeek(date, { weekStartsOn: 1 });
          endDate = endOfWeek(date, { weekStartsOn: 1 });
          break;
        case "yesterday":
           startDate = startOfYesterday()
           endDate = endOfYesterday()
           break;
        case "thisMonth":
          date = new Date();
          startDate = startOfMonth(date);
          endDate = subDays(date, 1);
          break;
        case "lastMonth":
          date = subMonths(new Date(), 1);
          startDate = startOfMonth(date);
          endDate = endOfMonth(date);
          break;
      }
      oneFuncRulesAll(
        startDate.getFullYear() +
          "/" +
          (startDate.getMonth() + 1) +
          "/" +
          startDate.getDate(),
        endDate.getFullYear() +
          "/" +
          (endDate.getMonth() + 1) +
          "/" +
          endDate.getDate(),
        new Date(
          startDate.getFullYear(),
          startDate.getMonth(),
          startDate.getDate()
        ),
        new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate()),
        "filter[date][starts]=" +
          startDate.getFullYear() +
          "-" +
          (startDate.getMonth() + 1) +
          "-" +
          startDate.getDate() +
          "&filter[date][ends]=" +
          endDate.getFullYear() +
          "-" +
          (endDate.getMonth() + 1) +
          "-" +
          endDate.getDate(),
        days
      );
    }
  };

  const clearHandler = () => {
    setCanSort(false);
    oneFuncRulesAll("----/--/--", "----/--/--", null, null, "", "");
  };
  const sortHandler = async () => {
    if (canSort) {
      await setNewRequest(!newRequest);
      setPopup(false);
    } else {
      setCKPopupType("Warning");
      setCKPopupMessage("dateExceeded");
      setCKPopup(true);
    }
  };

  const handleOpen = () => {
    setPopup(true);
  };
  const addDays = (date, days) => {
    const newDate = new Date(date);
    newDate.setDate(newDate.getDate() + days);
    return newDate;
  };
  return (
    <>
      <Ripples color="#0061FF40" during={600} className="rounded-2xl w-full">
        <Wrapper style={{ width: isMobile ? "100%" : width + "px" }}>
          <div
            className="flex flex-row justify-center items-center px-3 py-1"
            onClick={() => {
              handleOpen();
            }}
          >
            <div className="pr-2">
              <IconController src={assets.svg.calendar} alt="" />
            </div>
            <div className="flex-1">
              <span className="font-medium text-xs">
                {selectedStartDate} - {selectedEndDate}{" "}
              </span>
            </div>
            <div className="pl-2">
              <IconController
                src={assets.svg.chevronDown}
                className={`transition-transform ${popup ? "rotate-180" : ""}`}
                alt=""
              />
            </div>
          </div>
        </Wrapper>
      </Ripples>
      {popup ? (
        <>
          <Overlay
            onClick={() => {
              setPopup(false);
            }}
          ></Overlay>
          <Popup>
            <div className="modal">
              <div className="flex flex-col md:flex-row px-4">
                <div className="flex flex-row md:flex-col gap-2 py-3 md:py-4 date-a11y overflow-x-auto">
                  {dateOptions.map((day) => {
                    return (
                      <Ripples
                        color="#0061FF40"
                        during={600}
                        className="w-full"
                        key={day.days}
                      >
                        <span
                          onClick={() => {
                            daySelectHandler(day.days);
                          }}
                          className={`dateshde w-full ${
                            dateA11y === day.days ? "date-active" : ""
                          }`}
                        >
                          {day.title}
                        </span>
                      </Ripples>
                    );
                  })}
                </div>
                <div className="w-full h-full">
                  <DatePicker
                    wrapperClassName="datepicker"
                    selected={startDate}
                    onChange={onCalendarChange}
                    startDate={startDate}
                    endDate={endDate}
                    selectsRange
                    showYearDropdown
                    inline
                    maxDate={addDays(new Date(), -1)}
                    minDate={minDate}
                    locale={mn}
                    disabledKeyboardNavigation
                  />
                </div>
              </div>
              <div className="flex flex-row date-clear-field justify-between p-4 items-center">
                <div className="flex flex-row gap-1">
                  <IconController
                    src={assets.svg.calendarClear}
                    className="w-4 h-4"
                  />
                  <h5 className="text-xs font-medium">
                    {selectedStartDate} - {selectedEndDate}
                  </h5>
                </div>
                <div className="flex flex-row gap-2">
                  <Ripples
                    color="#0061FF40"
                    during={600}
                    className="rounded-3xl"
                  >
                    <div
                      className="clear-button"
                      onClick={() => {
                        clearHandler();
                      }}
                    >
                      <span className="text-xs">Цэвэрлэх</span>
                    </div>
                  </Ripples>
                  <Ripples
                    color="#ffffff40"
                    during={600}
                    className="rounded-3xl"
                  >
                    <div
                      className={` ${
                        canSort ? "sort-button" : "sort-button-disabled"
                      }`}
                      onClick={() => {
                        sortHandler();
                      }}
                    >
                      <span className="text-xs">Ангилах</span>
                    </div>
                  </Ripples>
                </div>
              </div>
            </div>
          </Popup>
        </>
      ) : (
        ""
      )}
    </>
  );
};

export default DateSelectDropdown;
